import site1 from "../assets/daily/site-1.jpg";
import site2 from "../assets/daily/site-2.jpg";
import site3 from "../assets/daily/site-3.jpg";
import site4 from "../assets/daily/site-4.jpg";
import site5 from "../assets/daily/site-5.jpg";
import { dailyPhotoFile } from "../photoPick";

/**
 * Daily 사진의 목 — 사무소 작업 사진 다섯 장(`work-thing/img1~5.jpg` 을 줄여 옮긴 것).
 *
 * 목에는 올린 파일 바이트를 두지 않으므로, 사진 id 마다 다섯 장 중 하나를 골라 준다.
 * 고르는 규칙은 vite 미들웨어와 함께 쓴다 → ../photoPick.ts
 */
const URL_BY_FILE: Record<string, string> = {
  "site-1.jpg": site1,
  "site-2.jpg": site2,
  "site-3.jpg": site3,
  "site-4.jpg": site4,
  "site-5.jpg": site5,
};

export const photoFor = (imageId: string) => URL_BY_FILE[dailyPhotoFile(imageId)];
